export const Language = "en";

export const API_URL = process.env.REACT_APP_API_URL;;

// export const API_URL = "https://webapi.ebol.cl/v1/api/";
// export const API_URL = "https://ebolapi.syprojects.world/v1/api/";
export const LIMIT = 5;
export const HEADER_ORIGIN_KEY = "p-source";
export const HEADER_ORIGIN = "cp";

export const updateNumber = value => {
  value = value.toString();
  let status = value.includes("-");
  if (status === false) {
    value =
      value.substr(0, value.length - 1) + "-" + value.substr(value.length - 1);
  }
  return value;
};
